import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

const testimonials = [
  {
    impact: 'Runs product management',
    quote:
      "I'm offloading product management to Pabs so I can focus on building the company.",
    author: 'Alberto Chierici',
    role: 'Solo Founder',
    company: null,
    tag: 'Product management',
  },
  {
    impact: 'Turns learnings into movement',
    quote:
      "I pasted the user interview transcripts into the Add Learning feature and I'm loving the updates across the board. Light-bulb moment :)",
    author: 'Sean Olanrewaju',
    role: 'Solo Founder',
    company: 'medly.nz',
    tag: 'Learnings',
  },
  {
    impact: 'Avoided days of wasted build',
    quote:
      "I was about to spend a couple of days building a feature I thought we needed. Pabs forced me to actually question it. Turned out I was solving the wrong problem. That probably saved me 2-3 days of work straight away.",
    author: 'Sean Olanrewaju',
    role: 'Solo Founder',
    company: 'medly.nz',
    tag: 'Avoided wasted build',
  },
  {
    impact: 'Exposes risk before momentum takes over',
    quote:
      "I just used PABS to help me make sense of a design challenge quickly. Super easy to use, quick, highlights risks and opportunities.",
    author: 'Hannah Gee',
    role: 'Consultant',
    company: 'neu21',
    tag: 'Risk signal',
  },
  {
    impact: 'Catches problem points before build',
    quote:
      "Pabs has been really interesting to play around with. It's quite helpful for identifying potential problem points that otherwise might go overlooked.",
    author: 'Hunter Clark',
    role: 'Solo Founder',
    company: null,
    tag: 'Scope check',
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-32 bg-brand-900 relative overflow-hidden border-t border-brand-50/10">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:80px_80px]"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-900/50 to-transparent"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">

          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-brand-50/5 border border-brand-50/10 rounded-full text-xs font-bold mb-8 backdrop-blur-md">
              <span className="text-brand-300 uppercase tracking-wider">Founder signals</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-bold mb-6 tracking-tighter leading-tight text-white">
              What solo founders need.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {testimonials.map((t, i) => (
              <TestimonialCard key={i} testimonial={t} delay={i * 0.08} />
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ testimonial, delay }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      viewport={{ once: true }}
      className="relative p-8 rounded-[2rem] bg-brand-50/[0.03] border border-brand-50/10 hover:bg-brand-50/[0.06] transition-colors duration-500 group flex flex-col"
    >
      <Quote className="w-8 h-8 text-brand-700 mb-6 shrink-0" />

      <div className="text-xs font-bold text-brand-300 uppercase tracking-widest mb-4">
        {testimonial.impact}
      </div>

      <p className="text-brand-200 leading-relaxed text-base flex-1 mb-8">
        "{testimonial.quote}"
      </p>

      <div className="flex items-center justify-between">
        <div>
          <div className="font-bold text-white text-sm">{testimonial.author}</div>
          <div className="text-xs text-brand-500 mt-0.5">
            {testimonial.role}{testimonial.company ? ` @ ${testimonial.company}` : ''}
          </div>
        </div>
        <span className="text-[10px] font-bold text-brand-400 uppercase tracking-widest px-3 py-1 bg-brand-50/5 border border-brand-50/10 rounded-full">
          {testimonial.tag}
        </span>
      </div>
    </motion.div>
  );
}
